import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { WarningAmber } from '@mui/icons-material';

interface InactivityWarningDialogProps {
  open: boolean;
  secondsUntilLogout: number;
  onStayLoggedIn: () => void;
}

export default function InactivityWarningDialog({
  open,
  secondsUntilLogout,
  onStayLoggedIn,
}: InactivityWarningDialogProps) {
  const minutes = Math.max(1, Math.ceil(secondsUntilLogout / 60));

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
      disableEscapeKeyDown
      aria-labelledby="inactivity-warning-title"
      aria-describedby="inactivity-warning-description"
    >
      <DialogTitle id="inactivity-warning-title" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmber color="warning" />
        Session timeout warning
      </DialogTitle>
      <DialogContent>
        <Typography id="inactivity-warning-description">
          You have been inactive for 14 minutes. For your security, you will be logged out automatically
          in about {minutes} {minutes === 1 ? 'minute' : 'minutes'} unless you continue working.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onStayLoggedIn} autoFocus>
          Stay logged in
        </Button>
      </DialogActions>
    </Dialog>
  );
}
